export const CategorySelectionItemPrice = (props) => {
  if (props.item.price > 0) {
    return (
      <td className="price">
        <span
          style={{ color: "#0054a1", fontSize: "21px", fontWeight: "bold" }}
        >
          {formatMoney(props.item.price)}
        </span>
      </td>
    );
  } else {
    return <td className="price"></td>;
  }
};
